export const isLocalEnv = () => {
  return (
    window.location.hostname === "localhost" ||
    window.location.hostname === "127.0.0.1" ||
    window.location.hostname === ""
  );
};

export const getMflApiEndpoint = () => {
  return "https://api.playmfl.com/";
};

export const getApiEndpoint = () => {
  if (isLocalEnv()) {
    return "http://127.0.0.1:5000/";
  }
  return "https://api." + window.location.hostname.replace("www.", "") + "/";
};

export const getGraphQLEndpoint = () => {
  return getApiEndpoint() + "graphql";
};

export const isAssistant = () => {
  return window.location.port === "3000" || window.location.hostname.includes("mfl-assistant.com");
};
